export default {
  props: {
    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    items: {
      type: Array,
    },
  },
}
